import {
  ClientPreleadCustomizeItem,
  PreleadMasterSearchConditionFilterCustomizeItem,
  useClientPreleadCustomizeItemsByProjectQuery,
  useProjectWithPreleadMasterSearchConditionQuery,
} from 'api';
import styled from 'styled-components';
import React from 'react';
import {useParams} from 'react-router';

export const CustomizeItems = () => {
  const {projectId} = useParams<{projectId: string}>();
  const {
    data: {
      project: {
        preleadMasterSearchCondition: {
          filter: {customizeItems = []} = {},
          mode = null,
        } = {},
      } = {},
    } = {},
  } = useProjectWithPreleadMasterSearchConditionQuery({
    variables: {uuid: projectId},
    skip: !projectId,
  });

  const upperCaseMode = mode?.toUpperCase();
  const {data: {clientPreleadCustomizeItemsByProject = []} = {}} =
    useClientPreleadCustomizeItemsByProjectQuery({
      variables: {uuid: projectId},
    });

  const customizeItemMap = Object.fromEntries(
    clientPreleadCustomizeItemsByProject.map((item) => [item.id, item]),
  );

  const getItemValue = (
    item: PreleadMasterSearchConditionFilterCustomizeItem,
    customizeItem: ClientPreleadCustomizeItem,
  ) => {
    switch (customizeItem.dataType) {
      case 'select':
        return item.values.length > 0
          ? item.values
              .map(
                (valueId) =>
                  customizeItem.selectOptions.find(
                    (option) => option.id === valueId,
                  )?.label || '',
              )
              .join(', ')
          : item.value;
      case 'number':
        return `${item.from}〜${item.to}`;
      case 'date':
        return `${item.startDate}〜${item.endDate}`;
      default:
        return item.value;
    }
  };

  return (
    <React.Fragment>
      {customizeItems?.length > 0 &&
        customizeItems.map((item, index) => {
          const customizeItem = customizeItemMap[item.id];
          if (!customizeItem) {
            return null;
          }

          const itemValue = getItemValue(item, customizeItem);

          return (
            <SearchCondition key={index}>
              <Title>
                <span>{upperCaseMode}：</span>
                {customizeItem.name}
              </Title>
              <TagBox>
                <TagItem>{itemValue}</TagItem>
              </TagBox>
            </SearchCondition>
          );
        })}
    </React.Fragment>
  );
};

const Title = styled.div`
  padding-top: 5px;
  width: 38%;

  span {
    color: #bdc4cb;
    width: 40px;
    display: inline-block;
  }
`;

const TagBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 62%;
`;

const TagItem = styled.span`
  margin: 0 5px 6px 0;
  padding: 5px 10px;
  background: #f3f5f7;
  border-radius: 4px;
  font-size: 12px;
  line-height: 17px;
  color: #495058;

  svg {
    margin-right: 6px;
  }
`;

const SearchCondition = styled.div`
  display: flex;
  margin-bottom: 10px;

  &:first-child {
    ${Title} {
      span {
        display: none;
      }
    }
  }
`;
